export default {"src":"/_next/static/media/img_survey_O.097871c0.svg","height":50,"width":50,"blurWidth":0,"blurHeight":0};